<div>
  <img *ngIf="value" src="{{value}}" alt="" class="avatar-image">
  
  <img *ngIf="!value" src="/assets/images/avatar.jpg" alt="" class="avatar-fallback">
  </div>